import type React from "react";
import { useContext, useMemo } from "react";
import { LoadingUI } from "../../components/Loading";
import { hasLicense, LICENSE_KEY } from "../../constants/licenses";
import { AuthContext } from "../../hooks/authProvider/authProvider";
import { useCrmPermission } from "../../hooks/useCrmPermission";
import { getCurrentTenant } from "../../utils/authority-utils";
import CrmDashboard from "./components/CrmDashboard";
import { HomePage } from "./HomePage";

const HomePageContainer: React.VFC = () => {
  const { currentUser, isLoadingUser, authError } = useContext(AuthContext);
  const { hasCrmAccess } = useCrmPermission();

  const licenses = useMemo(() => {
    const tenant = getCurrentTenant(currentUser);
    return tenant?.licenses;
  }, [currentUser]);

  const hasEmailSearch = useMemo(
    () => hasLicense(licenses, LICENSE_KEY.EMAIL_SEARCH),
    [licenses],
  );
  const hasBulkDelivery = useMemo(
    () => hasLicense(licenses, LICENSE_KEY.BULK_DELIVERY),
    [licenses],
  );

  if (authError) {
    return <div>{JSON.stringify(authError, null, 2)}</div>;
  }
  if (isLoadingUser || !currentUser) {
    return (
      <div className="flex justify-center mt-52">
        <LoadingUI type="Grid" />
      </div>
    );
  }

  if (hasCrmAccess) {
    return <CrmDashboard />;
  }

  return (
    <HomePage
      hasEmailSearch={hasEmailSearch}
      hasBulkDelivery={hasBulkDelivery}
    />
  );
};

export default HomePageContainer;
